import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaUsers } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { BASE_URL } from "../../constants";

function RefugeeCard() {
  const [userCount, setUserCount] = useState(0);
  const [newUserPercentage, setNewUserPercentage] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/refugees`);
        const users = response.data;
        const totalUsers = users.length;
console.log('total users number', totalUsers)
        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

        const newUsers = users.filter((user) => {
          const createdAt = new Date(user.createdAt);
          return createdAt >= oneMonthAgo;
        }).length;

        const percentage = ((newUsers / totalUsers) * 100).toFixed(2);

        setUserCount(totalUsers);
        setNewUserPercentage(percentage);
      } catch (error) {
        console.error("Error fetching users data:", error);
      } finally {
        setLoading(false); // Set loading to false once data is fetched
      }
    };

    fetchUsers();
  }, []);

  return (
<div
  style={{
    background: "linear-gradient(135deg, #6c757d 0%, #adb5bd 100%)", 
    borderRadius: "12px",
    color: "white",
    padding: "20px",
    boxShadow: "0px 19px 60px rgb(0 0 0 / 8%)",
  }}
  className="hover-scale w-100"
>
  <div className="card-body p-2">
    <div className="d-flex justify-content-between align-items-center flex-wrap">
      <FaUsers
        size={30}
        style={{
          stroke: "white",
          strokeWidth: "10px",
          filter: "drop-shadow(1px 2px 3px rgba(255, 255, 255, 0.5))",
        }}
      />

      <h6
        className="fw-bold mb-1 text-white text-truncate"
        style={{ fontSize: "1.2rem", minWidth: "120px" }}
      >
        {loading ? "..." : `${userCount.toLocaleString()} Users`}
      </h6>
    </div>
    <small
      className="text-white-40 d-block mt-1"
      style={{ fontSize: "0.85rem" }}
    >
      {loading
        ? "..."
        : `(${newUserPercentage}% ${newUserPercentage >= 0 ? "↑" : "↓"} From Last Month)`}
    </small>
  </div>
</div>

  
  );
}

export default RefugeeCard;